import axios from 'axios'

const baseUrl = '/api/points'

const updatePoints = async () => {
	const response = await axios.post(baseUrl)
	return response.data
}

export default { updatePoints }